import { createAsyncThunk } from '@reduxjs/toolkit'
import ContentCreator from './content-creator-model'
import {
  delete_contentCreator,
  load_contentCreators,
  store_contentCreator,
} from './contentCreator-service'

export const LoadContentCreatorsAsync = createAsyncThunk<any, any>(
  'composer/load/contentCreator',
  async (params: { uid: string }) => {
    return await load_contentCreators(params)
  },
)

export const CreateContentCreatorAsync = createAsyncThunk<any, any>(
  'composer/create/contentCreator',
  async (params: ContentCreator) => {
    return await store_contentCreator(params)
  },
)

export const DeleteContentCreatorAsync = createAsyncThunk<any, any>(
  'composer/delete/contentCreator',
  async (params) => {
    return await delete_contentCreator(params)
  },
)
